import * as React from "react";
import * as NotificationSystem from "react-notification-system";
import { Notification } from "react-notification-system";

/**
 * A component that wraps the react-notification-system.
 * Use addException and addNotification to show notifications to the user.
 *
 */
class NotificationComponent extends React.Component<{}, {}> {

    public render(): JSX.Element {
        return <NotificationSystem ref={(ref) => initializeSystem(ref)} />;
    }
}

let _notificationSystem: any | null = null;
let waitingNotifications: Notification[] = [];

export type MyNotification = Notification;

/**
 * Show an exception notification to the user.
 * @param name The name of the exeption
 * @param e the error or error message
 */
export function addException(name: string, e: Error | string) {
    // tslint:disable-next-line:no-console
    console.error(name, e);
    addNotification({
        title: "Oops, there has been a mistake" + ".",
        children: <ErrorNotification message={typeof e === "string" ? e : e.name} />,
        level: "error",
        autoDismiss: 0,
        dismissible: true,
        position: "br",
    });
}

/**
 * Show a notification to the user
 * @param notification the notification to show to the user
 */
export function addNotification(notification: MyNotification) {
    if (_notificationSystem) {
        fireNotification(_notificationSystem, notification);
    } else {
        waitingNotifications.push(notification);
    }
}

function fireNotification(system: any, notification: Notification) {
    if (system) {
        system.addNotification(notification);
    }
}

/**
 * initiaze the given system.
 * @param system the system to initialize.
 */
function initializeSystem(system: any) {
    if (!_notificationSystem) {
        _notificationSystem = system;
        if (waitingNotifications.length > 0) {
            waitingNotifications.forEach((notification) => fireNotification(system, notification));
            waitingNotifications = [];
        }
    }
}

function ErrorNotification(p: { message: string }) {
    return <div>{p.message}</div>;
}

export default NotificationComponent;



// WEBPACK FOOTER //
// ./src/Components/Shared/NotificationSystem/NotificationSystem.tsx